<div class="h-100 w-100 p-3 d-flex flex-column gap-3 config-text">
    <div class="d-flex align-items-center justify-content-between w-100 gap-1">
        <button class="d-flex align-items-center justify-content-center p-2 botao-com-icone"
            (click)="irParaTelaConfigGerais()">
            <object class="tamanho-icone" data="assets\agview-connect\arrow_back_white.svg"
                type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_TEXT.BACK" | transloco }}</object>
        </button>
        <div class="d-flex align-items-center barra-pesquisa px-2 w-100">
            <input type="text" placeholder="Buscar" class="w-100" (input)="filtrarConfiguracoes(filtro.value)" #filtro>
            <div class="d-flex flex-row align-items-center justify-content-center">
                <object class="w-100 h-100 p-2" data="assets\agview-connect\search_green.svg"
                    type="image/svg+xml">{{ "COMPONENTS.AGVIEW_CONNECT.CONFIG_TEXT.SEARCH" | transloco }}</object>
            </div>
        </div>
    </div>

    <div class="d-flex flex-column w-100 h-100 mh-100 overflow-y-auto container-cards-configuracao">
        <ng-container *ngFor="let item of arrayItensFiltrados">
            @if (item.deveSerMostrado) {
            <div class="config-card" [class.subconfiguracao]="item.isSubconfiguracao">
                <div class="d-flex flex-row align-items-center justify-content-between">
                    <div class="d-flex flex-column align-items-start justify-content-center flex-70">
                        <span class="titulo-card">{{item.titulo}}</span>
                        <span class="subtitulo-card">{{item.subtitulo}}</span>
                    </div>

                    @if (item.isToggle) {
                    <label class="switch" [class.borda-branca]="!item.valor">
                        <input type="checkbox" [(ngModel)]="item.valor" (ngModelChange)="mostrarItensOcultos(item)">
                        <span class="slider round"></span>
                    </label>
                    } @else {
                    <span class="titulo-card valor flex-15 text-center">{{item.valor + (item.unidadeMedida ? ' ' +
                        item.unidadeMedida : '' )}}</span>
                    <div class="d-flex flex-15 justify-content-end">
                        <button class="d-flex p-2 botao-com-icone" (click)="abrirDialog(item)">
                            <object data="assets\agview-connect\edit_grey.svg" type="image/svg+xml"></object>
                        </button>
                    </div>
                    }
                </div>
            </div>
            }
        </ng-container>
    </div>
</div>